import React from 'react'

import ColumnGridPanel from 'components/ColumnGridPanel'

import { SystemConfigReport, Lockout } from 'types/SystemConfigReport'

import { degrees, percentage } from 'helpers/formatters'

export type Props = Partial<SystemConfigReport> & Pick<SystemConfigReport, 'lockouts'>

const LOCKOUT_STATES = ['UNKNOWN', 'ENABLED', 'DISABLED', 'N/A']

const Lockouts = (report: Props) => {
  const lockoutValue = (lockout: Lockout | null) => {
    if (!lockout) { return 'N/A' }

    let value = `${LOCKOUT_STATES[lockout.state]}`

    if (LOCKOUT_STATES[lockout.state] === 'ENABLED') {
      value += ` (${degrees(lockout.temperature, 0)})`
    }

    return value
  }

  return (
    <ColumnGridPanel.Column>
      <ColumnGridPanel.Column.Header>Lockouts</ColumnGridPanel.Column.Header>
      <ColumnGridPanel.Column.Item label="Quiet Mode Day" value={report.quietModeAvailable ? percentage(report.dayTimeCompressorSpeed) : 'N/A'} />
      <ColumnGridPanel.Column.Item label="Quiet Mode Night" value={report.quietModeAvailable ? percentage(report.nightTimeCompressorSpeed) : 'N/A'} />
      <ColumnGridPanel.Column.Item label="Aux Heat" value={lockoutValue(report.lockouts?.auxiliaryHeat)} />
      <ColumnGridPanel.Column.Item label="Comp Heat" value={lockoutValue(report.lockouts?.compressorHeat)} />
      <ColumnGridPanel.Column.Item label="Cooling 1st Stg" value={lockoutValue(report.lockouts?.coolingFirstStage)} />
      <ColumnGridPanel.Column.Item label="Comp Heat 1st Stg" value={lockoutValue(report.lockouts?.heatingFirstStage)} />
      <ColumnGridPanel.Column.Item label="ID Heat 1st Stg" value={lockoutValue(report.lockouts?.indoorHeatingFirstStage)} />
    </ColumnGridPanel.Column>
  )
}

export default Lockouts
